const React = require('react'),
  {
    useState,
    useEffect
  } = React;
const {
  strategyWinnerCard,
  winnerCardSvg,
  saveWinnerImage,
  shareWinnerImage,
  publicShareLink,
  copyWinnerLink
} = require('./winnerCardExport');
require('./ShareYourWin.css');
function ShareYourWin({
  card,
  onOwnerShare
}) {
  const [message, setMessage] = useState(''),
    [busy, setBusy] = useState(false),
    [copyBlocked, setCopyBlocked] = useState(false),
    [ticket, setTicket] = useState(false);
  const identity = JSON.stringify([card?.target, card?.actual, card?.pick, card?.featuredStrategy]);
  useEffect(() => {
    setMessage('');
    setCopyBlocked(false);
    setTicket(false);
  }, [identity]);
  if (card?.status !== 'ready') return null;
  let selected, svg, link;
  try {
    selected = strategyWinnerCard(card, card.featuredStrategy || card.attributions?.[0]?.strategy);
    svg = winnerCardSvg(selected);
    link = publicShareLink(selected);
  } catch {
    return /*#__PURE__*/React.createElement("p", null, "This result is unavailable for public sharing.");
  }
  async function run(action) {
    setBusy(true);
    setMessage('');
    setCopyBlocked(false);
    try {
      const result = await action(selected);
      setMessage(result === 'cancelled' ? 'Sharing cancelled.' : result === 'shared' ? 'Shared.' : result === 'owner-ready' ? 'Owner strategy card ready. No ticket purchase or payout claim.' : result === 'copied' ? '✓ Link copied!' : 'Image download started.');
    } catch {
      setMessage('Your device could not complete this action. Download the image or use the public link below.');
      setCopyBlocked(true);
    } finally {
      setBusy(false);
    }
  }
  const owner = card.shareAudience === 'owner';
  return /*#__PURE__*/React.createElement("section", {
    className: "share-win",
    "aria-label": "Share Your Win"
  }, /*#__PURE__*/React.createElement("header", {
    className: "share-win-header"
  }, /*#__PURE__*/React.createElement("span", null, "VERIFIED STRATEGY HIT"), /*#__PURE__*/React.createElement("h2", null, "\uD83D\uDD25 SHARE YOUR WIN"), /*#__PURE__*/React.createElement("p", null, "Picked before the draw. Verified afterward.")), /*#__PURE__*/React.createElement("div", {
    className: "winner-card-image",
    dangerouslySetInnerHTML: {
      __html: svg
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "share-win-simple-actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "share-win-primary",
    disabled: busy,
    onClick: () => run(shareWinnerImage)
  }, owner ? 'Share Verified Strategy Hit' : 'Share My Win'), /*#__PURE__*/React.createElement("div", {
    className: "share-win-secondary"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: busy,
    onClick: () => run(saveWinnerImage)
  }, "Download Image"), /*#__PURE__*/React.createElement("button", {
    disabled: busy,
    onClick: () => run(copyWinnerLink)
  }, "Copy Link"))), /*#__PURE__*/React.createElement("button", {
    className: "share-win-upload",
    onClick: () => setTicket(v => !v),
    "aria-expanded": ticket
  }, "\uD83D\uDCF7 Upload My Winning Ticket"), ticket && /*#__PURE__*/React.createElement("div", {
    className: "share-win-ticket-notice"
  }, /*#__PURE__*/React.createElement("strong", null, "Ticket uploads are not available yet."), /*#__PURE__*/React.createElement("p", null, "Private storage and authorized review must be enabled first. No image can be uploaded or published here. You can share the verified Strategy Hit card without a ticket photo.")), card.ownerShareAvailable === true && onOwnerShare && !owner && /*#__PURE__*/React.createElement("button", {
    className: "share-win-owner",
    disabled: busy,
    onClick: () => run(async () => {
      await onOwnerShare();
      return 'owner-ready';
    })
  }, "Owner: Share Verified Strategy Hit"), /*#__PURE__*/React.createElement("p", {
    role: "status",
    "aria-live": "polite",
    className: "share-win-status"
  }, message), copyBlocked && /*#__PURE__*/React.createElement("p", {
    className: "share-win-link"
  }, "Public signup link: ", /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    rel: "noreferrer"
  }, link)), /*#__PURE__*/React.createElement("p", {
    className: "share-win-notice"
  }, "Verified strategy number match only. This does not prove anyone purchased a ticket or won money. Public links never unlock private picks."));
}
module.exports = ShareYourWin;
